import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import "./App.css";
import Header from "./components/Header/Header";
import Sidebar from "./components/SideBar/Sidebar";
import Footer from "./components/Footer/Footer";
import Ricky from "./features/ricky/ricky";
import LoginPage from "./pages/loginPage/LoginPage";
import { restoreAuth } from "./redux/actions/authActions";
import WelcomePage from "./pages/welcomePage/welcomePage";
import ShopifySarkanyApi from "./features/ricky/shopifySarkanyApi/shopifySarkanyApi";
import VtexApi from "./features/ricky/vtexApiItems/vtexApi";
import VtexOrder from "./features/ricky/vtexApiOrders/vtexOrder";
import ShopifyRickyOrder from "./features/ricky/shopifyOrders/shopifyRickyOrder";
import Sofia from "./features/sofia/sofia";
import SofiaShopifyApi from "./features/sofia/sofiaShopifyApi/SofiaShopifyApi";
import ShopifySofiaOrder from "./features/sofia/sofiaShopifyOrders/sofiaShopifyOrder";
function ProtectedLayout({ children }) {
  return (
    <div className="app">
      <Header />
      <div className="dashboard-page d-flex">
        <Sidebar />
        <div className="content flex-grow-1">
          {children}
        </div>
      </div>
      <Footer />
    </div>
  );
}

function App() {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  useEffect(() => {
    dispatch(restoreAuth());
  }, [dispatch]);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route
          path="/login"
          element={
            isAuthenticated ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <LoginPage />
            )
          }
        />

        <Route
          path="/dashboard"
          element={
            isAuthenticated ? (
              <ProtectedLayout>
                <WelcomePage />
              </ProtectedLayout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/ricky"
          element={
            isAuthenticated ? (
              <ProtectedLayout>
                <Ricky>
                  <VtexApi />
                </Ricky>
              </ProtectedLayout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/ricky/arg/p"
          element={
            isAuthenticated ? (
              <ProtectedLayout>
                <Ricky>
                  <VtexApi />
                </Ricky>
              </ProtectedLayout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/ricky/us/p"
          element={
            isAuthenticated ? (
              <ProtectedLayout>
                <Ricky>
                  <ShopifySarkanyApi />
                </Ricky>
              </ProtectedLayout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/ricky/arg/o"
          element={
            isAuthenticated ? (
              <ProtectedLayout>
                <Ricky>
                  <VtexOrder />
                </Ricky>
              </ProtectedLayout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/ricky/us/o"
          element={
            isAuthenticated ? (
              <ProtectedLayout>
                <Ricky>
                  <ShopifyRickyOrder />
                </Ricky>
              </ProtectedLayout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/sofia"
          element={
            isAuthenticated ? (
              <ProtectedLayout>
                <Sofia>
                  <SofiaShopifyApi />
                </Sofia>
              </ProtectedLayout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/sofia/arg/p"
          element={
            isAuthenticated ? (
              <ProtectedLayout>
                <Sofia>
                  <SofiaShopifyApi />
                </Sofia>
              </ProtectedLayout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="/dashboard/sofia/arg/o"
          element={
            isAuthenticated ? (
              <ProtectedLayout>
                <Sofia>
                  <ShopifySofiaOrder />
                </Sofia>
              </ProtectedLayout>
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        <Route
          path="*"
          element={
            isAuthenticated ? (
              <Navigate to="/" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
